<template>
  <div>
    <el-select
      v-model="select"
      v-focus
      popper-class="selectByProduct"
      filterable
      remote
      clearable
      :remote-method="remoteMethod"
			:loading="loading"
      @clear="selectClear"
      :placeholder="placeholder"
      ref="selectByProduct"
    >
      <el-option value="">
      </el-option>
    </el-select>
    <div class="table">
      <u-table
        :data="tableList"
        :border="false"
        size="small"
        stripe
        ref="table"
        :pagination-show="true"
        :total="total"
        :page-size="params.pageSize"
        :current-page="params.currentPage"
        @handlePageSize="handlePageSize"
        @row-click="rowClick"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <template slot="empty"> 没有查询到符合条件的记录 </template>
        <!-- <u-table-column type="selection" width="55"></u-table-column> -->
        <u-table-column prop="itemName" label="商品" width="180"></u-table-column>
        <u-table-column prop="itemSpec" label="规格" width="100"> </u-table-column>
        <u-table-column prop="availableQtyFormat" label="可用库存" width="100"> </u-table-column>
        <u-table-column prop="productionDate" label="生产日期" width="100" v-if="power.isEnableProductDate == 'Y'"></u-table-column>
        <u-table-column prop="flavor" label="多口味" width="140">
          <template slot-scope="{ row }">
            <el-select v-if="row.flavorList" v-model="row.flavor" placeholder="请选择多口味" value-key="flavorID" size="mini" @change="flavorChange(row)">
              <el-option
                v-for="item in row.flavorList"
                :key="item.flavorID"
                :label="item.flavorDesc"
                :value="item">
              </el-option>
            </el-select>
          </template>
        </u-table-column>
      </u-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parameter: {
      type: Object,
      default:  {}
    },
    placeholder: {
      type: String,
      default:  '请选择商品'
    },
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").onfocus = function (e) {
          e.currentTarget.select();
        };
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    return {
      select: {},
      tableList: [],
      params: {
        ...{
          url: '/Account/dataSearchVue/selectItemEnterDetailList.html',
          page: 1,
          size: 5,
          keyWords: ''
        },
        ...this.parameter
      },
      loading: false,
      total: 0,
      power: {},
      source: null
    };
  },
  watch: {
    '$store.state.power'(val) {
      this.power = val
    }
  },
  created() {
    this.getTableList()
    this.power = this.$store.state.power
    this.$nextTick(() => {
      $('.selectByProduct .el-scrollbar__view').html(this.$refs.table.$el)
    })
  },
  methods: {
    getTableList() {
      this.loading = true
      const CancelToken = this.$http.CancelToken;
      const source = CancelToken.source();
      if (this.source) {
        this.source.cancel()
      }
      this.$http.post(this.params.url, this.Qs.stringify(this.params), {
        cancelToken: source.token
      }).then(({ data: res }) => {
        this.loading = false
        if (res.code == 'success') {
          let { data, total } = JSON.parse(res.result)
          this.tableList = JSON.parse(data)
          this.total = total
        }
      })
      this.source = source
    },
    rowClick(row) {
      console.log(row)
      this.select = row
      this.$refs.selectByProduct.blur()
      this.$emit('select', row)
    },
    selectClear() {
      this.$refs.selectByProduct.focus()
      this.params.keyWords = ''
      this.select = ''
      this.getTableList()
    },
    remoteMethod(query) {
      this.select = query
      this.params.keyWords = query
      this.params.page = 1
      this.getTableList()
    },
    handlePageSize({ page, size }) {
      this.$refs.selectByProduct.focus()
      this.params.page = page
      this.params.size = size
      this.getTableList()
    },
    flavorChange(row) {
      this.$emit('select', row)
    },
    handleSelectionChange(row) {
      this.$emit('select', row)
    }
  },
};
</script>

<style scoped lang="less">
.selectByProduct {
  .el-select-dropdown__item {
    padding: 0;
    height: auto;
    line-height: normal;
  }
}
.table {
  display: none;
}
</style>